import IconButton from '@/components/Buttons/IconButton';
import TextField from '@/components/TextField/TextField';
import styled from '@emotion/styled';
import { KeyboardBackspace } from '@mui/icons-material';
import { TextFieldProps, Typography } from '@mui/material';

export const Title = styled(Typography)`
    letter-spacing: -0.48px;
`;

export const SubTitle = styled(Typography)`
    letter-spacing: 0.15px;
    color: ${({ theme }) => theme.colors.black[900]};
`;

export const ButtonTitleContainer = styled.div`
    display: flex;
    align-items: center;
`;

interface TitleWithBackButtonProps {
    onBackClick: () => void;
    title: string;
}

export function TitleWithBackButton({ title, onBackClick }: TitleWithBackButtonProps) {
    return (
        <ButtonTitleContainer>
            <IconButton ariaLabel="title-back" onClick={onBackClick} disableRipple>
                <KeyboardBackspace fontSize="large" color="secondary" />
            </IconButton>
            <Title variant="h2">{title}</Title>
        </ButtonTitleContainer>
    );
}

export const PromptContainer = styled.div`
    border-radius: 12px;
    background-color: ${({ theme }) => theme.colors.black[50]};
    padding: 24px;
    width: 100%;
`;

export const PromptText = styled(Typography)`
    font-weight: 600;
    letter-spacing: 0.15px;
    line-height: normal;
`;

const NameTextField = styled(TextField)`
    margin-top: 8px;
    margin-bottom: 32px;
    width: 100%;

    & .MuiInputBase-input {
        padding: 10.5px 16px;
    }

    & .MuiOutlinedInput-notchedOutline {
        border-color: ${({ theme }) => theme.colors.black[300]};
    }
`;

type Props = TextFieldProps;

export function NameYourVoice(textFieldProps: Props) {
    return (
        <>
            <Typography variant="h5">Name your voice</Typography>
            <NameTextField {...textFieldProps} />
        </>
    );
}
